export default {
  EINZEL: "b3cbc90e-5687-46ff-867b-19f6b29e1559",
  KOMBI: "6d693148-960e-4241-86b1-027252c69203",
  TEIL: "27eca724-ce01-4013-aef9-6cbbad730049"
};
